module.exports = __webpack_public_path__ + "img/favicon.90979b86.svg";